import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import jsQR from 'jsqr';
import Common from '../Common/common';
import constClass from '../../Constants/Constants';
import moment from 'moment';

const videoWidth = 500;
const videoHeight = 500;
const videoFrameRate = 5;

const constraints = {
  audio: false,
  video: {
    width: videoWidth,
    height: videoHeight,
    frameRate: {
      max: videoFrameRate,
    },
    facingMode: 'environment',
  },
};

const QRCodeScanner = (props) => {
  const { settings } = props;
  const history = useHistory();
  const videoRef = useRef(null);
  const [message, setMessage] = useState('');
  const intervalRef = useRef();
  const [scanning, setScanning] = useState(true);
  const canvasRef = useRef(null);
  const [isContinue, setIsContinue] = useState(false);
  const {setQrCodeData} = props;
  const [errorMessage, setErrorMessage] = useState('');
  const streamRef = useRef(null);
  const siteId = props.siteId;

  // カメラを止める
  const stopCamera = useCallback(() => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
    }
    if (videoRef.current) {
        videoRef.current.pause();
      videoRef.current.srcObject = null;
    }
    streamRef.current = null;
    setIsContinue(false);
  }, []);

  // 外部ブラウザ起動処理
  const scanQrExternal = useCallback(() => {
    if (window.liff.isInClient()) {
      window.open(`${process.env.REACT_APP_FRONTEND_URL}/${siteId}/qr?openExternalBrowser=1&timestamp=${moment().format('YYYYMMDDHHmmSS')}`, '_blank');
    } else {
      history.push(`/${siteId}/qr`);
    }
  }, [history, siteId]);

  // カメラ起動
  useEffect(() => {
    const openCamera = async () => {
      try {
        if (navigator.mediaDevices) {
          const video = videoRef.current;
          if (video) {
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            streamRef.current = stream;
            video.srcObject = stream;
            setIsContinue(true);
          }
        } else {
          console.log('mediaDevices not found');
          if (navigator.getUserMedia) {
            console.log('getUserMedia found');
            const video = videoRef.current;
            if (video) {
              const successFunc = (stream) => {
                streamRef.current = stream;
                video.srcObject = stream;
                setIsContinue(true);
              };
              const errorFunc = (err) => {
                console.log(err);
                setErrorMessage('二次元コード読取が起動できませんでした。(2)');
              }
              navigator.getUserMedia(constraints, successFunc, errorFunc);
            }
          } else {
            console.log('getUserMedia not found');
            setErrorMessage('ブラウザを起動します。');
            // 外部ブラウザの二次元コードリーダ起動
            scanQrExternal();
          }
        }
      } catch (err) {
        console.log(err);
        setErrorMessage('カメラを起動できませんでした。\nカメラ付き端末でご利用ください。');
      }
    };
    openCamera();
    return () => {
      stopCamera();
    }
  }, [scanQrExternal, stopCamera]);

  // QRコード解析ループ
  useEffect(() => {
    if (!isContinue) {
      return;
    }

    const decodeQRCode = () => {
      const context = canvasRef ? (canvasRef.current ? canvasRef.current.getContext('2d') : undefined) : undefined;
      const video = videoRef ? videoRef.current : undefined;

      if (!context || !video) {
        return;
      }

      context.drawImage(video, 0, 0, videoWidth, videoHeight);
      const imageData = context.getImageData(0, 0, videoWidth, videoHeight);
      const code = jsQR(imageData.data, videoWidth, videoHeight);
      return code ? code.data : undefined;
    };

    const intervalId = window.setInterval(() => {
      if (scanning) {
        const decodedValue = decodeQRCode();
        setQrCodeData(decodedValue);
        if (!decodedValue) {
          return;
        }
      }
    }, 1000 / videoFrameRate);
    intervalRef.current = intervalId;
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [isContinue, scanning]);

  useEffect(() => {
    if (!scanning) {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
      if (videoRef.current) {
        videoRef.current.pause();
      }
    }
  }, [scanning]);

  useEffect(() => {
    const unlisten = history.listen(() => {
      stopCamera();
    });
    return () => unlisten();
  }, [history, stopCamera]);

  return (
    <div>
      <div className="bg-white" style={{ display: 'grid' }}>
        {Common.getSettingValue(settings, 'BOOKING_QR_READ', '0') === constClass.FLAG.ON &&
          <div style={{ width: videoWidth, height: videoHeight, margin: '0 auto' }}>
            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
              <video
                autoPlay
                playsInline={true}
                ref={videoRef}
                className={`w-100 ${(videoRef && videoRef.current && videoRef.current.srcObject) ? '' : 'd-none'}`}
              >
                <canvas width={videoWidth} height={videoHeight} ref={canvasRef} />
              </video>
            </div>
          </div>
        }
        {errorMessage &&
          <div className="text-danger text-center">
            {Common.getBrString(errorMessage)}
          </div>
        }
        {message &&
          <div className="text-danger text-center">
            {Common.getBrString(message)}
          </div>
        }
      </div>
    </div>
  );
};

export default QRCodeScanner;
